type SessionResult = {
  data: { session: { access_token: string } | null };
  error: unknown;
};

/** API keys identify the project; only a user session authorizes browser work. */
export async function authenticatedFunctionHeaders(
  publishableKey: string,
  getSession: () => PromiseLike<SessionResult>
): Promise<Record<string, string>> {
  const { data, error } = await getSession();
  if (error || !data.session?.access_token) {
    throw new Error('Tu sesión expiró. Inicia sesión nuevamente.');
  }
  return {
    apikey: publishableKey,
    Authorization: `Bearer ${data.session.access_token}`,
  };
}
